import React, { useState, useEffect, useCallback } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { listarClubClientes, crearClubCliente, desactivarClubCliente, exportarClubClientes } from '../../services/fidelizacionApi';
import { usePlan } from '../context/PlanContext';

const FORM_VACIO = { nombre: '', telefono: '', email: '', fecha_nacimiento: '' };

const ModalNuevoCliente = ({ onGuardar, onCerrar }) => {
    const [form, setForm] = useState(FORM_VACIO);
    const [guardando, setGuardando] = useState(false);
    const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.nombre.trim() || !form.telefono.trim()) {
            toast.warning('Nombre y teléfono son obligatorios');
            return;
        }
        setGuardando(true);
        try {
            await crearClubCliente(form);
            toast.success('Cliente registrado');
            onGuardar();
        } catch (e) {
            toast.error(e.message);
        } finally {
            setGuardando(false);
        }
    };

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Agregar cliente</h5>
                        <button type="button" className="close" onClick={onCerrar}><span>&times;</span></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="form-group">
                                <label className="small font-weight-bold">NOMBRE *</label>
                                <input className="form-control" value={form.nombre}
                                    onChange={e => set('nombre', e.target.value)} placeholder="Nombre del cliente" />
                            </div>
                            <div className="form-group">
                                <label className="small font-weight-bold">TELÉFONO *</label>
                                <input className="form-control" type="tel" value={form.telefono}
                                    onChange={e => set('telefono', e.target.value)} placeholder="9XXXXXXXX" />
                            </div>
                            <div className="form-group">
                                <label className="small font-weight-bold">EMAIL</label>
                                <input className="form-control" type="email" value={form.email}
                                    onChange={e => set('email', e.target.value)} placeholder="opcional" />
                            </div>
                            <div className="form-group mb-0">
                                <label className="small font-weight-bold">FECHA DE NACIMIENTO</label>
                                <input className="form-control" type="date" value={form.fecha_nacimiento}
                                    onChange={e => set('fecha_nacimiento', e.target.value)} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onCerrar}>Cancelar</button>
                            <button type="submit" className="btn btn-primary" disabled={guardando}>
                                {guardando ? <span className="spinner-border spinner-border-sm mr-1" /> : null}
                                Guardar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

const calcularEdad = (fechaNac) => {
    if (!fechaNac) return null;
    const hoy = new Date();
    const nac = new Date(fechaNac);
    let edad = hoy.getFullYear() - nac.getFullYear();
    if (hoy.getMonth() < nac.getMonth() || (hoy.getMonth() === nac.getMonth() && hoy.getDate() < nac.getDate())) edad--;
    return edad;
};

const esCumpleanosProximo = (fechaNac, dias = 7) => {
    if (!fechaNac) return false;
    const hoy = new Date();
    const nac = new Date(fechaNac);
    const proxCump = new Date(hoy.getFullYear(), nac.getMonth(), nac.getDate());
    if (proxCump < hoy) proxCump.setFullYear(hoy.getFullYear() + 1);
    const diff = (proxCump - hoy) / (1000 * 60 * 60 * 24);
    return diff <= dias;
};

const Estrellas = ({ n }) => {
    const score = n === 0 ? 0 : n <= 2 ? 1 : n <= 5 ? 2 : n <= 10 ? 3 : n <= 20 ? 4 : 5;
    return (
        <span title={n + ' compras'}>
            {[1,2,3,4,5].map(i => (
                <span key={i} style={{ color: i <= score ? '#F59E0B' : '#CBD5E1', fontSize: 13 }}>★</span>
            ))}
        </span>
    );
};

const ESTADOS = { 1:'Pendiente', 2:'En cocina', 3:'Listo', 4:'En camino', 5:'Entregado', 6:'Anulado' };

const FilaCliente = ({ c, usaFidelizacion, onEliminar }) => {
    const [abierto, setAbierto] = useState(false);
    const [historial, setHistorial] = useState(null);
    const [cargandoHist, setCargandoHist] = useState(false);
    const config = require('../../config/apiConfig').default;

    const toggleHistorial = async () => {
        if (!abierto && historial === null) {
            setCargandoHist(true);
            try {
                const token = localStorage.getItem('token');
                const res = await fetch(config.api_url + '/api/fidelizacion/clientes/' + c.id + '/historial', { headers: { token } });
                const data = await res.json();
                setHistorial(data.ok ? data.data : []);
            } catch (e) {
                setHistorial([]);
            } finally {
                setCargandoHist(false);
            }
        }
        setAbierto(v => !v);
    };

    const proxCump = esCumpleanosProximo(c.fecha_nacimiento);
    const edad = calcularEdad(c.fecha_nacimiento);

    return (
        <>
            <tr onClick={toggleHistorial} style={{ cursor: 'pointer' }}
                className={abierto ? 'table-active' : ''}>
                <td className="align-middle" style={{ width: 20, paddingRight: 0 }}>
                    <span style={{ fontSize: 10, color: '#9CA3AF', display: 'inline-block', transform: abierto ? 'rotate(90deg)' : 'none', transition: 'transform 0.15s' }}>▶</span>
                </td>
                <td className="align-middle font-weight-bold">{c.nombre}</td>
                <td className="align-middle small">{c.telefono}</td>
                <td className="align-middle">
                    <Estrellas n={c.cantidad_compras != null ? c.cantidad_compras : 0} />
                </td>
                <td className="align-middle">
                    <span className="badge badge-light border" style={{ fontVariantNumeric: 'tabular-nums' }}>
                        {c.cantidad_compras != null ? c.cantidad_compras : 0} compras
                    </span>
                </td>
                <td className="align-middle text-muted small">
                    {c.fecha_nacimiento ? (
                        <span>
                            {new Date(c.fecha_nacimiento + 'T12:00:00').toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit' })}
                            {edad !== null && <small className="text-muted ml-1">({edad}a)</small>}
                            {proxCump && <span className="ml-1" title="Cumpleaños próximo">🎂</span>}
                        </span>
                    ) : '—'}
                </td>
                {usaFidelizacion && (
                    <td className="align-middle">
                        {c.puntos_acumulados > 0
                            ? <span className="badge badge-success">{c.puntos_acumulados} pts</span>
                            : <span className="text-muted">0</span>}
                    </td>
                )}
                {usaFidelizacion && (
                    <td className="align-middle">
                        <span className={`badge ${c.origen === 'carta' ? 'badge-primary' : c.origen === 'importacion' ? 'badge-warning' : 'badge-secondary'}`}>
                            {c.origen === 'carta' ? 'Carta QR' : c.origen === 'importacion' ? 'Importado' : 'Manual'}
                        </span>
                    </td>
                )}
                <td className="align-middle text-muted small">{new Date(c.fecha_registro).toLocaleDateString('es-CL')}</td>
                <td className="align-middle" onClick={e => e.stopPropagation()}>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => onEliminar(c.id, c.nombre)} title="Desactivar">
                        <i className="bi bi-trash" />
                    </button>
                </td>
            </tr>
            {abierto && (
                <tr>
                    <td colSpan={usaFidelizacion ? 10 : 8} style={{ background: '#F8FAFC', padding: '12px 16px 14px 40px', borderTop: '1px solid #E2E8F0' }}>
                        <div style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#64748B', marginBottom: 8 }}>
                            Historial de compras
                        </div>
                        {cargandoHist ? (
                            <div className="spinner-border spinner-border-sm text-primary" />
                        ) : !historial || historial.length === 0 ? (
                            <span className="text-muted small">Sin compras registradas.</span>
                        ) : (
                            <table className="table table-sm mb-0" style={{ fontSize: 12, maxWidth: 600 }}>
                                <thead>
                                    <tr>
                                        <th>Fecha</th><th>Pedido</th><th>Total</th><th>Estado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historial.map(p => (
                                        <tr key={p.id}>
                                            <td>{new Date(p.fecha_creacion).toLocaleDateString('es-CL')}</td>
                                            <td className="text-muted">#{p.id}</td>
                                            <td style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
                                                ${Number(p.total_pagado || 0).toLocaleString('es-CL')}
                                            </td>
                                            <td>
                                                <span className={`badge ${p.estado_id === 5 ? 'badge-success' : p.estado_id === 6 ? 'badge-danger' : 'badge-secondary'}`}>
                                                    {ESTADOS[p.estado_id] || p.estado_id}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </td>
                </tr>
            )}
        </>
    );
};

const MantenedorClubClientes = () => {
    const { usaFidelizacion: usaFidelizacionCtx } = usePlan();
    const usaFidelizacion = usaFidelizacionCtx || false;
    const [clientes, setClientes] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [busqueda, setBusqueda] = useState('');
    const [cargando, setCargando] = useState(true);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [exportando, setExportando] = useState(false);

    const cargar = useCallback(async () => {
        setCargando(true);
        try {
            const data = await listarClubClientes({ page, q: busqueda });
            setClientes(data.data || []);
            setTotal(data.total || 0);
        } catch (e) {
            toast.error('Error al cargar clientes');
        } finally {
            setCargando(false);
        }
    }, [page, busqueda]);

    useEffect(() => { cargar(); }, [cargar]);

    const handleBusqueda = (e) => {
        setBusqueda(e.target.value);
        setPage(1);
    };

    const handleEliminar = async (id, nombre) => {
        if (!window.confirm(`¿Desactivar a ${nombre} del club?`)) return;
        try {
            await desactivarClubCliente(id);
            toast.success('Cliente desactivado');
            cargar();
        } catch (e) {
            toast.error(e.message);
        }
    };

    const totalPaginas = Math.ceil(total / 50);

    const handleExportar = async () => {
        setExportando(true);
        try {
            const datos = await exportarClubClientes();
            const encabezado = ['Nombre', 'Teléfono', 'Email', 'Fecha Nacimiento', 'Dirección', 'Puntos', 'Última Compra', 'N° Compras', 'Total Compras', 'Fecha Registro'];
            const filas = datos.map(c => [
                c.nombre || '',
                c.telefono || '',
                c.email || '',
                c.fecha_nacimiento || '',
                c.direccion || '',
                c.puntos_acumulados != null ? c.puntos_acumulados : 0,
                c.ultima_compra || '',
                c.cantidad_compras != null ? c.cantidad_compras : 0,
                c.total_compras != null ? c.total_compras : 0,
                c.fecha_creacion || '',
            ]);
            const csv = [encabezado, ...filas]
                .map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
                .join('\r\n');
            const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `clientes_${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        } catch (e) {
            toast.error('Error al exportar: ' + e.message);
        } finally {
            setExportando(false);
        }
    };

    return (
        <div className="container-fluid py-4">
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="font-weight-bold mb-1">Club de clientes</h4>
                    <p className="text-muted mb-0">{total} cliente{total !== 1 ? 's' : ''} registrado{total !== 1 ? 's' : ''}</p>
                </div>
                <div className="d-flex gap-2">
                    <button className="btn btn-outline-success" onClick={handleExportar} disabled={exportando}>
                        {exportando
                            ? <span className="spinner-border spinner-border-sm mr-1" />
                            : <i className="bi bi-file-earmark-excel mr-1"></i>}
                        Exportar Excel
                    </button>
                    <button className="btn btn-primary" onClick={() => setModalAbierto(true)}>
                        + Agregar cliente
                    </button>
                </div>
            </div>

            {/* Buscador */}
            <div className="mb-3" style={{ maxWidth: 400 }}>
                <input className="form-control" placeholder="Buscar por nombre, teléfono o email..."
                    value={busqueda} onChange={handleBusqueda} />
            </div>

            {/* Tabla */}
            <div className="card shadow-sm">
                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: 20 }}></th>
                                <th>Nombre</th>
                                <th>Teléfono</th>
                                <th>Valoración</th>
                                <th>Compras</th>
                                <th>Cumpleaños</th>
                                {usaFidelizacion && <th>Puntos</th>}
                                {usaFidelizacion && <th>Origen</th>}
                                <th>Registro</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {cargando ? (
                                <tr>
                                    <td colSpan={usaFidelizacion ? 10 : 8} className="text-center py-4">
                                        <div className="spinner-border spinner-border-sm text-primary" />
                                    </td>
                                </tr>
                            ) : clientes.length === 0 ? (
                                <tr>
                                    <td colSpan={usaFidelizacion ? 10 : 8} className="text-center py-5 text-muted">
                                        {busqueda ? 'Sin resultados para esa búsqueda.' : 'Aún no hay clientes registrados.'}
                                    </td>
                                </tr>
                            ) : clientes.map(c => (
                                <FilaCliente key={c.id} c={c} usaFidelizacion={usaFidelizacion} onEliminar={handleEliminar} />
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Paginación */}
                {totalPaginas > 1 && (
                    <div className="card-footer d-flex justify-content-between align-items-center">
                        <small className="text-muted">Página {page} de {totalPaginas}</small>
                        <div>
                            <button className="btn btn-sm btn-outline-secondary mr-2"
                                disabled={page === 1} onClick={() => setPage(p => p - 1)}>
                                ‹ Anterior
                            </button>
                            <button className="btn btn-sm btn-outline-secondary"
                                disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>
                                Siguiente ›
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {modalAbierto && (
                <ModalNuevoCliente
                    onGuardar={() => { setModalAbierto(false); cargar(); }}
                    onCerrar={() => setModalAbierto(false)}
                />
            )}
        </div>
    );
};

export default MantenedorClubClientes;
